import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ViaCepResponse } from '../models/viacep.model';

@Injectable({
  providedIn: 'root',
})
export class ViaCepService {
  private readonly URL_VIA_CEP = 'https://viacep.com.br/ws/';

  constructor(private httpClient: HttpClient) {}

  getCep(cep: string): Observable<ViaCepResponse> {
    return this.httpClient.get<ViaCepResponse>(
      `${this.URL_VIA_CEP}${cep}/json`
    );
  }
}
